<template>
  <div class="index-index-warp">
    <van-sticky>
      <van-nav-bar title="问问分享PK大作战">
        <template #left>
          <van-icon name="arrow-left" size="18" @click="onClickLeft('left')" />
        </template>
        <template #right>
          <van-icon name="question-o" size="18" @click="onClickLeft('right')" />活动规则
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="pk_index_index_active">
      <div class="pk_nav_tab">
        <div class="left" @click="setActive" :class="{ active: active }">
          分享拉新
        </div>
        <div class="right" @click="setActive" :class="{ active: !active }">
          销售额成交
        </div>
      </div>
      <div class="pk_nav_time">
        <div>
          下次刷新时间：<van-count-down
            :time="time"
            format="mm:ss"
            @finish="finish"
          />
        </div>
        <div>活动结束时间：11月2日 00:00</div>
      </div>
      <div class="pk_top_content">
        <div class="pk_top_card pk_top_card_two">
          <div class="title">
            <img src="../../assets/outher/2.png" alt="" class="img1" />
            <img src="../../assets/outher/down.png" alt="" class="img" />
            <span>第二名</span>
          </div>
          <div class="name van-ellipsis">小三空间看</div>
          <div class="price">300</div>
          <div class="tag">第2名</div>
        </div>
        <div class="pk_top_card pk_top_card_one">
          <div class="title">
            <img src="../../assets/outher/1.png" alt="" class="img1" />
            <img src="../../assets/outher/down.png" alt="" class="img" />
            <span>第一名</span>
          </div>
          <div class="name van-ellipsis">小三空间看小三空间看</div>
          <div class="price">300</div>
          <div class="tag">小三空间看小三空间看</div>
        </div>
        <div class="pk_top_card pk_top_card_three">
          <div class="title">
            <img src="../../assets/outher/3.png" alt="" class="img1" />
            <img src="../../assets/outher/down.png" alt="" class="img" />
            <span>第三名</span>
          </div>
          <div class="name van-ellipsis">小三空间看</div>
          <div class="price">300</div>
          <div class="tag">第3名</div>
        </div>
      </div>
      <div class="pk_top_btn" @click="jumpToUrl('prize')">
        <p>奖励清单</p>
      </div>
    </div>
    <div class="pk_index_index_item">
      <div class="item_card">
        <li class="box">
          <div class="item_img"></div>
          <div class="item_name">蜜蜂昵称</div>
          <div class="item_price">成交金额</div>
          <div class="item_j">奖励</div>
        </li>
        <ul>
          <li class="box_item">
            <div class="item_img">
              <img src="../../assets/outher/down.png" alt="" class="img" />
              <span>第三名</span>
            </div>
            <div class="item_name">蜜蜂昵称</div>
            <div class="item_price">成交金额</div>
            <div class="item_j">奖励</div>
          </li>
          <li class="box_item">
            <div class="item_img">
              <img src="../../assets/outher/down.png" alt="" class="img" />
              <span>第三名</span>
            </div>
            <div class="item_name">蜜蜂昵称</div>
            <div class="item_price">成交金额</div>
            <div class="item_j">奖励</div>
          </li>
          <li class="box_item">
            <div class="item_img">
              <img src="../../assets/outher/down.png" alt="" class="img" />
              <span>第三名</span>
            </div>
            <div class="item_name">蜜蜂昵称</div>
            <div class="item_price">成交金额</div>
            <div class="item_j">奖励</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer_bottom_flex">
      <div class="item_img">
        <img src="../../assets/outher/down.png" alt="" class="img" />
        <span>第三名</span>
      </div>
      <div class="item_info">
        <p class="p1">
          <span>我</span>
          <span class="price">333元</span>
        </p>
        <p class="p2">距离超越上一名还需成交<span class="price">333</span>元</p>
      </div>
      <div class="item_icon" @click="jumpToUrl('details')">
        <span > <van-icon name="arrow" size="12"/> </span>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/common'
export default {
  data() {
    return {
      active: true,
      time: 240000,
    };
  },
  methods: {
    setActive() {
      this.active = !this.active;
    },
    finish() {
      this.time = 240000;
      // 在重新调接口
    },
    onClickLeft(item){
      if(item ==='left'){
        utils.goBack()
      }else{
        utils.jumpToNewPage({url: window.location.origin +'/h5user/activityPreview?accode=152'})
      }
    },
    jumpToUrl(item){
      switch (item) {
        case 'prize':
          utils.jumpToNewPage({url: window.location.origin +'/h5user/pkInActivityDetails?type='+this.active?'sharePrize':'dealPrize'})
          break;
        case 'details':
          utils.jumpToNewPage({url: window.location.origin +'/h5user/pkInActivityDetails?type='+this.active?'shareItem':'dealItem'});
          break;
        default:
          break;
      }
    }
  },
  created() {
    this.$loading.hide();
  },
};
</script>
<style lang="less" scoped>
.pk_index_index_active {
  background: url("../../assets/outher/bg.png");
  background-size: 100% 100%;
  // height: 760px;
  .pk_nav_tab {
    font-size: 28px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 40px;
    div {
      background: linear-gradient(180deg, #ff8800 0%, #ff3539 100%);
      width: 50%;
      text-align: center;
      padding: 20px 0;
    }
    .left {
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
    }
    .right {
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
    }
    .active {
      background: linear-gradient(360deg, #ffffff 0%, #e7e7e7 100%);
      color: #999;
    }
  }
  .pk_nav_time {
    color: #cd2824;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 40px 10px 40px;
    div {
      width: 50%;
      text-align: left;
      .van-count-down {
        color: #cd2824;
        font-size: 24px;
        display: inline;
        line-height: none;
      }
    }
  }
  .pk_top_content {
    display: flex;
    justify-content: space-around;
    padding-top: 190px;
    box-sizing: border-box;
    .pk_top_card_one {
      .img {
        border: 6px solid #fed530 !important;
      }
    }
    .pk_top_card_three {
      .img {
        border: 6px solid #cdb195 !important;
      }
    }
    .pk_top_card {
      width: 210px;
      background: linear-gradient(180deg, #ffefe5 0%, #ffffff 100%);
      border-radius: 20px;
      text-align: center;
      .title {
        position: relative;
        padding: 41px 41px 0 41px;
        text-align: center;
        font-size: 28px;
        span {
          font-size: 18px;
          color: #ad6b04;
          border-radius: 5px;
          padding: 5px;
          background: linear-gradient(180deg, #fcec76 0%, #f8d541 100%);
        }
        .img1 {
          width: 51px;
          height: 46px;
          position: absolute;
          top: 35px;
          left: 35px;
          z-index: 2;
        }
        .img {
          width: 120px;
          height: 120px;
          object-fit: cover;
          position: relative;
          box-sizing: border-box;
          border: 6px solid #ffffff;
          border-radius: 50%;
        }
      }
      .name {
        color: #333;
        font-size: 28px;
        padding: 12px 8px;
      }
      .price {
        color: #ed3939;
        font-size: 28px;
        padding-bottom: 15px;
      }
      .tag {
        font-size: 20px;
        background: #ed3939;
        border-radius: 10px;
        color: #fff;
        margin: 0 20px 20px 20px;
      }
    }
    .pk_top_card_two {
      margin-top: 25px;
    }
    .pk_top_card_three {
      margin-top: 25px;
    }
  }
  .pk_top_btn {
    text-align: center;
    padding: 25px 0;
    p {
      width: 177px;
      border-radius: 10px;
      color: #cd2824;
      font-size: 28px;
      padding: 7px 0;
      display: inline-block;
      background: linear-gradient(180deg, #fcec76 0%, #f8d541 100%);
    }
  }
}
.pk_index_index_item {
  background: #f58d23;
  padding: 0 30px 165px 30px;

  .item_card {
    font-size: 24px;
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    .box {
      list-style: none;
      display: flex;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      height: 110px;
      .item_img {
        width: 100px;
      }
      .item_name {
        width: 210px;
        padding: 0 10px;
      }
      .item_price {
        width: 121px;
        padding: 0 10px;
      }
      .item_j {
        width: 190px;
        padding: 0 10px;
      }
    }
    .box_item {
      list-style: none;
      display: flex;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      height: 110px;
      .item_img {
        font-size: 18px;
        position: relative;
        width: 100px;
        .img {
          width: 70px;
          height: 70px;
          border: 4px solid #fed530;
          border-radius: 50%;
        }
        span {
          width: 100px;
          background: linear-gradient(180deg, #fcec76 0%, #f8d541 100%);
          border-radius: 10px;
          color: #ad6b04;
          padding: 5px;
          position: absolute;
          left: 0;
          bottom: -5px;
          font-size: 12px;
        }
      }
      .item_name {
        width: 210px;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;
      }
      .item_price {
        width: 121px;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 24px;
        color: #ed3939;
      }
      .item_j {
        width: 190px;
        padding: 0 10px;
        box-sizing: border-box;
        background: #ed3939;
        color: #fff;
        font-size: 20px;
        border-radius: 10px;
      }
    }
  }
  .box {
    font-size: 20px;
    color: #666;
  }
}
.footer_bottom_flex {
  display: flex;
  height: 135px;
  width: 100%;
  background: #fff;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  box-sizing: border-box;
  bottom: 0;
  .item_img{
    width: 150px;
    position: relative;
    text-align: center;
    .img{
      width: 90px;
      height: 90px;
      border: 4px solid #FED530;
      border-radius: 50%;
    }
    span {
      width: 100px;
      background: linear-gradient(180deg, #fcec76 0%, #f8d541 100%);
      border-radius: 10px;
      color: #ad6b04;
      text-align: center;
      padding: 5px;
      position: absolute;
      left: 20px;
      bottom: 0;
      font-size: 12px;
    }
  }
  .item_info{
    flex: 1;
    font-size: 24px;
    color: #666;
    padding: 0 20px;
    .p1{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333;
      font-size: 28px;
    }
    .price{
      color: #ED3939;
    }
  }
  .item_icon{
    width: 150px;
    text-align: right;
    .van-icon-arrow{
      background: #F8D541;
      color: #333;
      border-radius: 50%;
      padding: 10px;
    }
  }
}
.van-nav-bar .van-icon {
  color: #999;
}
/deep/.van-nav-bar__right {
  color: #999;
}
</style>